import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon, ChevronRightIcon } from 'lucide-react';
import { DesignNote } from '../components/DesignNote';
import { annualEvents, eventsIntro, submitFields, weekendPicks } from '../data/events';
export function Events() {
  return <main id="main" className="bg-paper" data-id="element-729" data-mp="2phao5kw8va5q">
      <div className="mx-auto max-w-shell px-6 pb-14 pt-8 lg:px-10" data-id="element-730" data-mp="2pg94is15xfce">
        <nav aria-label="Breadcrumb" data-id="element-731" data-mp="2bpe1hwdchsgq">
          <ol className="flex items-center gap-2 text-[12.5px] text-muted" data-id="element-732" data-mp="2bocd6q7bj9h2">
            <li data-id="element-733" data-mp="2ghxbkjctq5gs">
              <Link to="/" className="hover:text-ink hover:underline" data-id="element-734" data-mp="2gigmhg423tlb">
                Home
              </Link>
            </li>
            <ChevronRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-735" data-mp="26rc8ojq4aes2" />
            <li aria-current="page" className="text-ink" data-id="element-736" data-mp="26p85k401ljsu">
              Family events
            </li>
          </ol>
        </nav>

        <div className="mt-12 max-w-3xl" data-id="element-737" data-mp="1wswpr418ubtn">
          <p className="label text-olive" data-id="element-738" data-mp="1wrv64b65wh0b">
            {eventsIntro.count} · {eventsIntro.updated}
          </p>
          <h1 className="mt-6 font-display text-[48px] font-300 leading-[0.98] text-ink sm:text-[64px]" data-id="element-739" data-mp="1c34uzfgcggih">
            Family events in <span className="italic" data-id="element-740" data-mp="1788yo342r6zk">Santa Barbara</span>
          </h1>
          <p className="mt-7 max-w-prose text-[16px] leading-[1.85] text-muted" data-id="element-741" data-mp="1m2nejusce0a0">
            {eventsIntro.deck}
          </p>
        </div>
      </div>

      <Picks data-id="element-742" data-mp="tdyjacdywp66" />
      <CalendarEmbed data-id="element-743" data-mp="tdouut8kmq2l" />
      <Submit data-id="element-744" data-mp="tezv4j2t5foy" />
      <Annual data-id="element-745" data-mp="terkyyy2kohg" />
    </main>;
}
function Picks() {
  return <section aria-labelledby="picks-h" className="border-t border-line bg-white" data-id="element-746" data-mp="ogg8shkay1w2">
      <div className="mx-auto max-w-shell px-6 py-20 lg:px-10 lg:py-24" data-id="element-747" data-mp="134t91qqfa6wd">
        <DesignNote label="Written by you" note="This part is real text on your domain, so it can rank and it is why the page holds 2:47. Keep it above the embed." data-id="element-748" data-mp="ydkxao1me9g1" />
        <h2 id="picks-h" className="max-w-2xl font-display text-[38px] font-300 leading-[1.05] text-ink sm:text-[46px]" data-id="element-749" data-mp="alnluy231jfg">
          Our five picks for this weekend
        </h2>
        <p className="mt-5 max-w-prose text-[15.5px] leading-[1.8] text-muted" data-id="element-750" data-mp="zemt9l66mmyl">
          Chosen and checked on Thursday. Everything else is on the calendar
          below.
        </p>

        <ul className="mt-14 border-t border-line" data-id="element-751" data-mp="147pcazdc2e0j">
          {weekendPicks.map(pick => <li key={pick.id} data-id="element-752" data-mp="196k2wnhjl6v7">
              <article className="grid gap-y-4 border-b border-line py-8 lg:grid-cols-[130px_1fr_190px] lg:gap-x-12" data-id="element-753" data-mp="cegmk00dgp72">
                <p className="label pt-1 text-olive" data-id="element-754" data-mp="gf0jp3ky3st7">
                  {pick.day}
                  <span className="mt-1.5 block text-muted/80" data-id="element-755" data-mp="lebyw85nyq8o">{pick.date}</span>
                </p>
                <div data-id="element-756" data-mp="qehlh9x2tmjw">
                  <h3 className="font-display text-[29px] font-300 leading-tight text-ink" data-id="element-757" data-mp="qezs90hd7j62">
                    {pick.name}
                  </h3>
                  <p className="mt-2 text-[13.5px] text-muted" data-id="element-758" data-mp="1wwee70m7qndc">
                    {pick.place} · {pick.time}
                  </p>
                  <p className="mt-4 max-w-prose text-[15.5px] leading-[1.8] text-ink/75" data-id="element-759" data-mp="3mbfeljv91f21">
                    {pick.note}
                  </p>
                </div>
                <dl className="grid grid-cols-2 gap-x-6 self-start lg:grid-cols-1 lg:gap-y-4" data-id="element-760" data-mp="3hefavflvgoe3">
                  <div data-id="element-761" data-mp="3cizy6qzloyj9">
                    <dt className="label text-muted/70" data-id="element-762" data-mp="37mt0tml9svcx">Cost</dt>
                    <dd className="mt-1.5 text-[14px] text-ink" data-id="element-763" data-mp="37k6t9mydqfup">{pick.cost}</dd>
                  </div>
                  <div data-id="element-764" data-mp="33ibhtpmqim37">
                    <dt className="label text-muted/70" data-id="element-765" data-mp="2yluswt7po3p2">Ages</dt>
                    <dd className="mt-1.5 text-[14px] text-ink" data-id="element-766" data-mp="2yno2ag9pl20r">{pick.ages}</dd>
                  </div>
                </dl>
              </article>
            </li>)}
        </ul>
      </div>
    </section>;
}
function CalendarEmbed() {
  const days = Array.from({
    length: 35
  });
  const busy = [3, 5, 8, 11, 12, 16, 19, 22, 24, 25, 29, 31];
  return <section aria-labelledby="calendar-h" className="bg-paper" data-id="element-767" data-mp="mx3mdaohbbkr">
      <div className="mx-auto max-w-shell px-6 py-20 lg:px-10 lg:py-24" data-id="element-768" data-mp="uwqcx4k3bmx1">
        <DesignNote label="Third-party embed" note="Tockify or Google Calendar lives here. It handles recurring events and public submissions — the two things Squarespace cannot do. It will not be indexed, which is fine because the copy above is." data-id="element-769" data-mp="uundxv0ymjg6" />
        <h2 id="calendar-h" className="max-w-2xl font-display text-[38px] font-300 leading-[1.05] text-ink sm:text-[46px]" data-id="element-770" data-mp="pw2cxtdvvvqo">
          The full June calendar
        </h2>

        <div className="mt-12 border border-dashed border-olive/60 bg-white p-8 lg:p-12" data-id="element-771" data-mp="gyi9qewgnpdf">
          <div className="flex flex-wrap items-baseline justify-between gap-4 border-b border-line pb-6" data-id="element-772" data-mp="29dpyta0pd37">
            <p className="font-display text-[30px] font-300 text-ink" data-id="element-773" data-mp="77nmp8be4lqx">June 2026</p>
            <p className="label text-muted" data-id="element-774" data-mp="3pdtq3m10e2ha">38 events</p>
          </div>

          <div className="mt-8 grid grid-cols-7 gap-px bg-line" data-id="element-775" data-mp="3tevpc2uxeej9">
            {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map((d, i) => <div key={`${d}-${i}`} className="bg-white pb-3 pt-1 text-center" data-id="element-776" data-mp="3aquynr25j82k" data-mpi={i}>
                <span className="label text-muted/70" data-id="element-777" data-mp="35rqmcrjxku80">{d}</span>
              </div>)}
            {days.map((_, i) => {
            const dayNum = i - 0;
            const isBusy = busy.includes(dayNum);
            return <div key={i} className="min-h-[74px] bg-white p-2.5" aria-hidden="true" data-id="element-778" data-mp="3etrnhziac0ey" data-mpi={i}>
                  <span className="text-[12px] text-muted/70" data-id="element-779" data-mp="3oorz4yjq7ymi">
                    {dayNum > 0 && dayNum <= 30 ? dayNum : ''}
                  </span>
                  {isBusy && <span className="mt-2 block space-y-1" data-id="element-780" data-mp="2a04r13c0y0m">
                      <span className="block h-1.5 w-full bg-opal" data-id="element-781" data-mp="2cmcb0q83diu" />
                      {dayNum % 3 === 0 && <span className="block h-1.5 w-2/3 bg-peach" data-id="element-782" data-mp="bb6p5l93qsz5" />}
                    </span>}
                </div>;
          })}
          </div>

          <p className="mt-8 text-center text-[12.5px] italic text-muted" data-id="element-783" data-mp="3948dykcxtlip">
            Embed region — styled to match, managed outside Squarespace
          </p>
        </div>
      </div>
    </section>;
}
function Submit() {
  return <section aria-labelledby="submit-h" className="bg-opal/35" data-id="element-784" data-mp="3iv32xwhkiz7u">
      <div className="mx-auto grid max-w-shell gap-14 px-6 py-20 lg:grid-cols-2 lg:px-10 lg:py-24" data-id="element-785" data-mp="3nto0fo5fr4sl">
        <div data-id="element-786" data-mp="3srzde7r11vf1">
          <p className="label text-ink/60" data-id="element-787" data-mp="3srpl2diifc66">Free, always</p>
          <h2 id="submit-h" className="mt-6 font-display text-[38px] font-300 leading-[1.05] text-ink sm:text-[46px]" data-id="element-788" data-mp="3subtefd85vpg">
            Submit your local event
          </h2>
          <p className="mt-6 max-w-md text-[15.5px] leading-[1.85] text-ink/75" data-id="element-789" data-mp="22g2vbl0tuak6">
            Anyone can add an event. Submissions come to us first, get checked
            against the details below, and go live within a day or two. Repeat
            events only need submitting once.
          </p>
          <p className="mt-6 max-w-md text-[14px] leading-[1.8] text-ink/60" data-id="element-790" data-mp="1v4wug833g214">
            Running a business? A paid placement puts your event at the top of
            the weekend picks, clearly labeled.
          </p>
        </div>

        <form onSubmit={e => e.preventDefault()} className="bg-paper px-8 py-9" aria-label="Submit an event" data-id="element-791" data-mp="1l7ih4hcgvtd1">
          <div className="grid gap-6 sm:grid-cols-2" data-id="element-792" data-mp="2iseo695x5a6q">
            {submitFields.map((field, i) => <div key={field} className={i >= submitFields.length - 1 ? 'sm:col-span-2' : ''} data-id="element-793" data-mp="2dtld0ne3tv9q" data-mpi={i}>
                <label htmlFor={`field-${i}`} className="label block text-muted" data-id="element-794" data-mp="24vhttxqldal3">
                  {field}
                </label>
                <input id={`field-${i}`} type="text" className="mt-2 w-full border-b border-ink/25 bg-transparent py-2.5 text-[15px] text-ink focus:border-olive focus:outline-none" data-id="element-795" data-mp="tf1hidac3a2g" />
              </div>)}
          </div>
          <button type="submit" className="label mt-10 bg-ink px-8 py-4 text-paper transition-colors duration-150 ease-soft hover:bg-olive" data-id="element-796" data-mp="2jk62ltc1h30w">
            Send it in
          </button>
        </form>
      </div>
    </section>;
}
function Annual() {
  return <section aria-labelledby="annual-h" className="border-t border-line bg-white" data-id="element-797" data-mp="3gaf3hi0piksc">
      <div className="mx-auto max-w-shell px-6 py-20 lg:px-10 lg:py-24" data-id="element-798" data-mp="32iiehmuc4r06">
        <DesignNote label="Real pages, not calendar entries" note="Six to eight of these. They rank all year for “fiesta with kids” and similar, and they are where the embed's traffic gets caught." data-id="element-799" data-mp="32gee3evnaa4n" />
        <h2 id="annual-h" className="max-w-2xl font-display text-[38px] font-300 leading-[1.05] text-ink sm:text-[46px]" data-id="element-800" data-mp="3s8i0gzgdffk">
          The ones that come around every year
        </h2>

        <ul className="mt-14 grid gap-x-14 gap-y-9 border-t border-line pt-12 sm:grid-cols-2 lg:grid-cols-4" data-id="element-801" data-mp="968j9mxdl4vf">
          {annualEvents.map(event => <li key={event.slug} className="group relative border-b border-line pb-6" data-id="element-802" data-mp="mwc2s64vekh6">
              <p className="label text-muted/70" data-id="element-803" data-mp="hyk8j5gr6m9t">{event.when}</p>
              <h3 className="mt-3 font-display text-[23px] font-300 leading-snug text-ink" data-id="element-804" data-mp="3qd2b4rnxd9m1">
                <Link to="/blog" className="decoration-olive decoration-1 underline-offset-[6px] after:absolute after:inset-0 after:content-[''] group-hover:underline" data-id="element-805" data-mp="3mcqpbbjtt38z">
                  {event.name}
                </Link>
              </h3>
              <ArrowUpRightIcon className="mt-4 h-3.5 w-3.5 text-muted/60" aria-hidden="true" data-id="element-806" data-mp="1fl9h5y5ynx4n" />
            </li>)}
        </ul>
      </div>
    </section>;
}